import {  Snackbar } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeAlertBox } from "../../redux/features/alertbox.features";
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const AlertBox = () => {
  const dispatch = useDispatch();
   
  let alertState = useSelector((state) => {
    return state.alertBoxReducer;
  });
  let { show,type, msg } = alertState;

  

  const handleClose = (event, reason) => {
    dispatch(closeAlertBox())
  };
  return (
    <Snackbar open={show} autoHideDuration={6000} onClose={handleClose} >
      <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
        {msg}
      </Alert>
    </Snackbar>
  );
};

export default AlertBox;
